/**
 * Model dispatcher. Each model is a self-contained calculator;
 * `calculateBudget` picks the right one based on profile.budgetModel.
 */

import type { AppData } from '../../data/types';
import type { PayPeriod } from '../payPeriod';
import { calculateDaily, type DailyModelResult, type DailyStatus } from './daily';
import { calculatePYF, type PayYourselfFirstResult } from './pyf';
import {
  calculate503020,
  type BucketResult,
  type FiftyThirtyTwentyResult,
} from './fiftythirtytwenty';
import {
  calculateZero,
  calculateZeroBased,
  type CategoryAllocation,
  type ZeroBasedResult,
} from './zero';

export type BudgetResult =
  | DailyModelResult
  | PayYourselfFirstResult
  | FiftyThirtyTwentyResult
  | ZeroBasedResult;

export function calculateBudget(
  data: AppData,
  period: PayPeriod,
  today: Date,
): BudgetResult {
  switch (data.profile.budgetModel) {
    case 'pyf':
      return calculatePYF(data, period, today);
    case '503020':
      return calculate503020(data, period, today);
    case 'zero':
      return calculateZero(data, period, today);
    case 'daily':
    case 'conscious':
    default:
      return calculateDaily(data, period, today);
  }
}

export {
  calculateDaily,
  calculatePYF,
  calculate503020,
  calculateZero,
  calculateZeroBased,
};
export type {
  DailyModelResult,
  DailyStatus,
  PayYourselfFirstResult,
  FiftyThirtyTwentyResult,
  BucketResult,
  ZeroBasedResult,
  CategoryAllocation,
};
export * from './shared';
